import { Grid } from '@material-ui/core';
import { AccountCircle as AccountIcon } from '@material-ui/icons';
import React from 'react';
import { useIntl } from 'react-intl';
import messages from '../messages';

const UserRole = {
  system_admin: 'Admin',
  tap_to_tip_agent: 'Guide'
};

const ProfileOverview = ({ user, selectedUser, handleSelectUser }) => {
  const { userId, firstName, lastName, email, avatarUrl, assignedCardsAmount, role } = user;
  const isSelectedUser = selectedUser && selectedUser === userId;
  const isActive = assignedCardsAmount;
  const intl = useIntl();

  return (
    <Grid
      className={`grid grid-cols-[20%_80%] my-5 rounded-2xl cursor-pointer transition-colors duration-150 ${
        isSelectedUser ? 'bg-indigo-50' : 'hover:bg-slate-50'
      }`}
      onClick={() => handleSelectUser(userId)}>
      <Grid className="flex justify-center">
        {avatarUrl ? (
          <img
            src={avatarUrl}
            className="w-[47px] h-[47px] mt-1 rounded-full object-cover"
            alt="Profile Avatar"
          />
        ) : (
          <AccountIcon className="mt-1 text-slate-300" style={{ width: 47, height: 47 }} />
        )}
      </Grid>
      <Grid className="text-xs font-medium text-slate-600 [&>*]:my-1">
        <div className="text-sm font-semibold text-slate-800">
          {firstName || ''} {lastName || ''}
        </div>
        <div>{email}</div>
        <div>
          {intl.formatMessage(messages.type)}: {UserRole[role]}
        </div>
        <div
          className={`inline-flex items-center px-3 py-1 w-fit rounded-md text-[11px] font-bold border border-solid ${
            isActive
              ? 'bg-emerald-50 text-emerald-700 border-emerald-200/55'
              : 'bg-slate-100 text-slate-500 border-slate-200/55'
          }`}>
          {intl.formatMessage(messages.activeCards)}: {assignedCardsAmount}
        </div>
      </Grid>
    </Grid>
  );
};

export default ProfileOverview;
